'use client';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { cn } from '@/lib/utils';
import { MARKDOWN_STYLES } from '@/constants/chat.constants';
import { getMarkdownComponents } from './MarkdownComponents';

interface MarkdownRendererProps {
  content: string;
  isUser?: boolean;
  className?: string;
  onNavigate?: (href: string) => void;
}

export function MarkdownRenderer({ content, isUser = false, className, onNavigate }: MarkdownRendererProps) {
  return (
    <div className={cn(isUser ? MARKDOWN_STYLES.PROSE_WHITE : MARKDOWN_STYLES.PROSE, className)}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        className='[&>*:first-child]:mt-0 [&>*:last-child]:mb-0'
        components={getMarkdownComponents({ isUser, onNavigate })}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
